import React, { useState, useEffect } from 'react';
import { gameRequests } from '../../request/requests';
import QuestionEditor from './QuestionEditor';

export default function Admin(){

    const [questions, setQuestions] = useState([]);
    const [newQuestion, setNewQuestion] = useState('');

    const loadQuestions = async () => {
        const res = await gameRequests.getQuestions();
        if(res.success){
            setQuestions(res.data);
        }else{
            alert(res.msg);
        }
    };

    useEffect(() => {
        loadQuestions();
    }, []);

    return (
        <div style={{padding: '30px', position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: '#f0f0f0', overflow: 'scroll'}}>
            <h1>Admin Pannel</h1>

            <div style={{marginTop: '20px'}}>
                <h2>
                    Questions :
                </h2>

                <div>
                    <input value={newQuestion} onChange={(e)=>{setNewQuestion(e.target.value)}} type="text" placeholder='Nouvelle question' />
                    <button onClick={()=>{gameRequests.createQuestion(newQuestion); setNewQuestion(''); loadQuestions();}}>
                        Ajouter
                    </button>
                </div>

                <div style={{marginTop: '20px'}}>
                    {
                        questions.map((question, index) => {
                            return (
                                <QuestionEditor loadQuestions={loadQuestions} question={question} key={index}/>
                            );
                        })
                    }
                </div>
            </div>
        </div>
    );
}